import React from "react";
import DiwaliBackground from "../Components/Background";
import DiwaliGiftPopup from "../Components/Email_Popup";  //"../Components/exhaust";   //"../Components/Email_Popup"; 
import OTP_Popup from "./Otp_popup";
import GiftCardSelection from "./GiftCardSelection";
import GiftCardSelectionCake from "./GiftCardSelectionCake";
import PurchaseDetails from "./PurchaseDetails";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Home = () => {
  return (
    <DiwaliBackground>
     <Routes>
        <Route path="/" element={<DiwaliGiftPopup />} />
        <Route path="/otp" element={<OTP_Popup />} />
        <Route path="/gift-selection" element={<GiftCardSelection />} />
        <Route path="/gift-selection-cake" element={<GiftCardSelectionCake />} />
        <Route path="/purchase-details" element={<PurchaseDetails />} />
      </Routes>
    </DiwaliBackground>
  );
};

export default Home;
